<script setup>
import { computed } from 'vue'
import TripFinderSegmentedControl from './TripFinderSegmentedControl.vue'

const props = defineProps({
  modelValue: {
    type: String,
    required: true,
  },
  variant: {
    type: String,
    default: 'desktop',
    validator: (value) => ['desktop', 'mobile'].includes(value),
  },
})

const emit = defineEmits(['update:modelValue'])

const options = computed(() => {
  if (props.variant === 'mobile') {
    return [
      {
        value: 'build',
        label: 'Plan Trip',
        buttonClass: 'px-0 py-[14px] -translate-x-[4px]',
        sliderLeftOffset: -2,
        sliderWidthOffset: 2,
      },
      {
        value: 'recommend',
        label: 'Discover Trips',
        buttonClass: 'px-2 py-[10px] translate-x-[2px]',
        sliderLeftOffset: 2,
        sliderWidthOffset: 2,
      },
    ]
  }

  return [
    { value: 'build', label: 'Plan Trip' },
    { value: 'recommend', label: 'Discover Trips' },
  ]
})
</script>

<template>
  <TripFinderSegmentedControl
    aria-label="Trip mode selector"
    :model-value="modelValue"
    :options="options"
    :variant="variant"
    @update:modelValue="emit('update:modelValue', $event)"
  />
</template>
